@import '../components/match-context/match-context';
@import '../components/match-scorers/match-scorers';
@import '../components/match-live-penalties/match-live-penalties';
@import '../components/match-cards/match-cards';
@import '../components/match-missed-penalties/match-missed-penalties';

@import './pk-match-header.variables';

.pk-match-header {
  @apply bg-[color:--match-header--background-color];
  font-family: var(--match-header--font-family);

  .pk-match-header__mu {
    --match-unit--background-color: transparent;
    --match-unit--shadow: transparent;
    --match-info--font-size: theme(fontSize.s);
    --match-info--font-size--mobile: theme(fontSize.xs);

    &::part(container) {
      @apply grid-rows-[minmax(26px,_auto)_minmax(32px,_auto)];
    }

    &::part(match-base) {
      @apply mt-2 @00/match-header:[--match-base--team-name-font-family:--pk-font-base-semibold] @sm/match-header:[--match-base--team-name-font-family:--pk-font-comp-bold];
    }

    &.is-live-penalties::part(match-bottom) {
      @apply hidden;
    }

    &::part(team-home-name),
    &::part(team-away-name) {
      @apply @00/match-header:text-s @xs/match-header:text-xl2 @sm/match-header:text-xl4;
    }

    &::part(match-score-goals) {
      @apply @00/match-header:text-xl @xs/match-header:text-xl2 @sm/match-header:text-xl3;
    }

    &::part(team-home-badge),
    &::part(team-away-badge) {
      @apply @00/match-header:[--badge--size:32px] @xs/match-header:[--badge--size:48px];
    }

    &::part(match-time) {
      @apply @00/match-header:text-m @xs/match-header:text-xl @sm/match-header:text-xl2;
    }
  }
}

.pk-match-header.is-compact-mode {
  .pk-match-header__mu {
    @apply p-0;

    &::part(container) {
      @apply flex;
    }

    &::part(match-base) {
      @apply mt-0;
    }

    &::part(match-top),
    &::part(match-bottom) {
      @apply hidden;
    }

    &::part(team-home-badge),
    &::part(team-away-badge) {
      @apply @00/match-header:[--badge--size:24px] @sm/match-header:[--badge--size:32px];
    }

    &::part(match-score-goals) {
      @apply text-l;
    }

    &::part(match-time) {
      @apply @00/match-header:text-m @sm/match-header:text-l;
    }

    &::part(team-home-name),
    &::part(team-away-name) {
      @apply @00/match-header:text-s @sm/match-header:text-l;
    }
  }
}
